<template>
    <b-container fluid class="animated fadeIn">
        <b-alert :show="showDismissibleAlert" @dismissed="showDismissibleAlert = false" dismissible variant="warning">

            <p class="mb-0" v-html="dividasErro"></p>

        </b-alert>
        <h1>Protesto - Exibir Dívida Disponível</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i
                                    class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna :fields="fields" :showColunms="showColunms"
                                @toggleColuna="toggleColuna" />
                        </div>
                        <b-button class="mx-1 fonte-branca" @click.prevent="relatorioPDF" style="float:right; height: 35px"
                            variant="primary"><i class="fa fa-file-pdf-o" v-if="!loadPDF"></i>
                            <b-spinner small v-if="loadPDF"></b-spinner> Relatório de Títulos por Comarca disponibilizado na
                            Carga de Dívidas</b-button>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect v-model="filtrarPor" :show-labels="false" :options="opcoesFiltro"
                                                :multiple="true" :close-on-select="false" :clear-on-select="false"
                                                :preserve-search="true" placeholder="Selecione" track-by="id"
                                                label="filtro">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="Nº da Dívida:" label-for="numeroDivida" class="text-label">
                                            <b-form-input v-model="filtro.numeroDivida" type="number" id="numeroDivida"
                                                maxlength="8" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="6" lg="3" xl="3">
                                        <b-form-group label="CPF/CNPJ:" label-for="cpfCnpj" class="text-label">
                                            <the-mask id="cpfCnpj" class="form-control" v-model="filtro.cpfCnpj"
                                                :mask="['XX.XXX.XXX/XXXX-##', 'XXX.XXX.XXX-XX']" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Contribuinte:" label-for="contribuinte" class="text-label">
                                            <b-form-input v-model="filtro.contribuinte" type="text" id="contribuinte"
                                                maxlength="100" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 4).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="CADICMS:" label-for="cadicms" class="text-label">
                                            <b-form-input v-model="filtro.cadimcs" type="text" id="cadicms"
                                                maxlength="20" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 5).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Comarca:" label-for="comarca" class="text-label">
                                            <multiselect v-model="filtro.comarca" :show-labels="false"
                                                :options="dados.comarcas" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="codComarca">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 6).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="8" xl="8">
                                        <b-form-group label="Origem:" label-for="origem" class="text-label">
                                            <b-form-input v-model="filtro.origem" type="text" id="origem" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 7).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                                            <multiselect v-model="filtro.credito" :show-labels="false"
                                                :options="dados.creditos" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 8).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Início):" label-for="dtInscricaoInicio"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoInicio"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Data de Inscrição (Fim)" label-for="dtInscricaoFim"
                                            class="text-label">
                                            <b-form-input type="date" v-model="filtro.dtInscricaoFim"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 9).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Situação CADICMS:" label-for="situacaoCadicms"
                                            class="text-label">
                                            <multiselect v-model="filtro.situacaoCadicms" :show-labels="false"
                                                :options="dados.situacoesCadicms" :multiple="true" :close-on-select="false"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 10).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="3" xl="3">
                                        <b-form-group label="Exceção Inativa:" label-for="excecaoInativa"
                                            class="text-label">
                                            <multiselect v-model="filtro.excecaoInativa" :show-labels="false"
                                                :options="dadosExcecaoInativa" :multiple="false" :close-on-select="true"
                                                :clear-on-select="false" :preserve-search="true" placeholder="Selecione"
                                                label="nome" track-by="id">
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }}
                                                        selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button variant="primary" class="fonte-branca" @click="filtrar">
                                                <i class="fa fa-search"></i> Pesquisar
                                            </b-button>
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                    <b-row class="d-flex justify-content-between mt-2">
                        <CompAvisos />
                        <b-col align-self="end" class="col-md-12">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1" variant="primary" @click.prevent="disponibilizarParaAjuizamento"
                                        :disabled="isDateNow"><i class="fa fa-pencil-square-o"></i> Disponibilizar para
                                        Ajuizamento</b-button>
                                    <b-button class="mx-1" variant="primary" @click.prevent="selecionarParaProtesto"
                                        :disabled="isDateNow"><i class="fa fa-pencil-square-o"></i> Selecionar para
                                        Protesto</b-button>
                                    <b-button class="mx-1" variant="primary"
                                        @click.prevent="showModal('modalJustificativa')" :disabled="isDateNow"><i
                                            class="fa fa-warning"></i> Encaminhar para Exceções</b-button>
                                    <b-button class="mx-1" variant="primary" @click.prevent="selecionarTodosParaProtesto"
                                        :disabled="checkDateNow"><i class="fa fa-pencil-square-o"></i> Selecionar tudo para
                                        Protesto</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Dívidas Disponibilizadas - Valor Total: <strong>R$ {{
                                                configTable.totalGeral | currency }}</strong> &nbsp; Quantidade:
                                                <strong>{{ configTable.quantidadeGeral }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                    <CompTabelaCDADisponivelProtesto :resultado="resultado" :fields="fields"
                                        :configTable="configTable" :selecteds="selecteds" @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas" />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Quantidade selecionada: {{ selecteds.length }} &nbsp;
                                                Valor Total: <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <CompPaginacao :configTable="configTable" />
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1 " variant="primary" :disabled="loadCSV" @click.prevent="exportCSV"><i
                                        class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar"><i class="fa fa-reply"></i>
                                    Voltar</b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
        <b-modal ref="modalJustificativa" size="lg" title="Justificativa" cancel-title="Fechar">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-form-textarea id="justificativa" v-model="justificativa" placeholder="Informe aqui a justificativa.."
                        rows="3" max-rows="6">
                    </b-form-textarea>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{}">
                <div style="width:100%; text-align:center">
                    <b-button size="md" variant="success" @click="encaminharExecoes()" class="float-left">
                        Confirmar
                    </b-button>
                </div>
            </template>
        </b-modal>
        <b-modal ref="modalError" size="lg" title="Alerta envio de CDA's" cancel-title="Fechar">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Não foi possível enviar as CDA's listadas abaixo por já possuirem código
                        de remessa:</p>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <p>{{ erroDividasComRemessa }}</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{}">
                <div class="d-flex justify-content-between">
                    <b-button variant="primary" class="fonte-branca ml-1" @click="hideModal('modalError')">
                        Ok
                    </b-button>
                </div>
            </template>
        </b-modal>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompPaginacao from './components/CompPaginacao'
import CompTabelaCDADisponivelProtesto from './components/CompTabelaCDADisponivelProtesto'
import CompAvisos from './components/CompCDADisponivelProtestoAvisos'

export default {
    name: 'CDADisponivelProtesto',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        CompTabelaCDADisponivelProtesto,
        CompAvisos
    },
    data() {
        return {
            ano: null,
            mes: null,
            filtrarPor: [],
            dividasErro: null,
            showDismissibleAlert: false,
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Número da Dívida'
                },
                {
                    id: 2,
                    filtro: 'CPF/CNPJ'
                },
                {
                    id: 3,
                    filtro: 'Contribuinte'
                },
                {
                    id: 4,
                    filtro: 'CADICMS'
                },
                {
                    id: 5,
                    filtro: 'Comarca'
                },
                {
                    id: 6,
                    filtro: 'Origem'
                },
                {
                    id: 7,
                    filtro: 'Tipo Crédito'
                },
                {
                    id: 8,
                    filtro: 'Data Inscrição'
                },
                {
                    id: 9,
                    filtro: 'Situação CADICMS'
                },
                {
                    id: 10,
                    filtro: 'Exceção Inativa'
                }
            ],
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                origem: null,
                situacaoCadicms: null,
                excecaoInativa: null
            },
            dadosExcecaoInativa: [{ id: 1, idString: null, nome: 'Sim' }, { id: 2, idString: null, nome: 'Não' }],
            dados: {
                comarcas: [],
                creditos: [],
                situacoesCadicms: []
            },
            configTable: {
                perPage: 100,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0
            },
            showColunms: [],
            selecteds: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            loadCSV: false,
            loadPDF: false,
            justificativa: null,
            erroDividasComRemessa: null
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
        isDateNow() {
            const dataAtual = new Date()
            const anoAtual = dataAtual.getFullYear()
            const mesAtual = dataAtual.getMonth() + 1

            if (anoAtual === this.ano && mesAtual === this.mes) {
                if (this.selecteds.length) {
                    return false
                }
            }
            return true
        },
        checkDateNow() {
            const dataAtual = new Date();
            const anoAtual = dataAtual.getFullYear();
            const mesAtual = dataAtual.getMonth() + 1;

            return !(anoAtual === this.ano && mesAtual === this.mes);
        }
    },
    methods: {
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
                origem: null,
                situacaoCadicms: null
            }
            this.filtrarPor = []
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.configTable.rows = 0
            this.configTable.checkedAll = false
            this.resultado = []
            this.selecteds = []
            this.consultarDividas()
        },

        /**
         * Disponibilizar para Ajuizamento
         */
        disponibilizarParaAjuizamento() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            let selecionadas = []
            this.selecteds.forEach(cda => {
                selecionadas.push({
                    codCdaSefa: cda.codCdaSefa,
                    numeroDivida: cda.numeroDivida
                })
            })

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/disponibilizarParaAjuizamento`, selecionadas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((resp) => {
                    let possuiErro = false;
                    if (resp.data != null) {
                        let erro = resp.data;

                        if (erro.dividasRetornoRemessa != null && erro.dividasRetornoRemessa != '') {
                            this.erroDividasComRemessa = erro.dividasRetornoRemessa;
                            this.showModal('modalError');
                            possuiErro = true;
                        } else if (erro.listaDividasErro != null && erro.listaDividasErro.length > 0) {
                            let dividasStr = ''
                            erro.listaDividasErro.forEach(divida => {
                                if (dividasStr !== '') {
                                    dividasStr += ', '
                                }
                                dividasStr += `<a href="/consultar-cda/${divida}" target="_blank">${divida}</a>`
                            })
                            this.dividasErro = 'Não foi possível completar a operação!!! ' + dividasStr
                            this.showDismissibleAlert = true
                            possuiErro = true;
                        }
                    }
                    if (!possuiErro) {
                        this.showDismissibleAlert = false
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Operação realizada com sucesso!!!'] });
                    }
                    this.selecteds = []
                    this.configTable.checkedAll = false
                })
                .finally(() => {
                    this.configTable.currentPage = 1
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        /**
         * Selecionar para Protesto
         */
        selecionarParaProtesto() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            let selecionadas = []
            this.selecteds.forEach(cda => {
                selecionadas.push({
                    codCdaSefa: cda.codCdaSefa,
                    numeroDivida: cda.numeroDivida
                })
            })

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/selecionarParaProtesto`, selecionadas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((resp) => {
                    let erro = resp.data;
                    let possuiErro = false;

                    if (erro.dividasRetornoRemessa != null && erro.dividasRetornoRemessa != '') {
                        this.erroDividasComRemessa = erro.dividasRetornoRemessa;
                        this.showModal('modalError');
                        possuiErro = true;
                    } else {
                        this.dividasErro = '';
                        if (erro.comarcasErro != null && erro.comarcasErro.length > 0) {
                            possuiErro = true;
                            let comarcasStr = ''
                            erro.comarcasErro.forEach(comarca => {
                                if (comarcasStr !== '') {
                                    comarcasStr += ', '
                                }
                                comarcasStr += `${comarca}`
                            })
                            this.dividasErro = 'Títulos da(s) comarca(s) ' + comarcasStr + ' não foram deslocados para a ' +
                                'caixa CDA’s Selecionadas em virtude de já ter sido atingido o limite diário de envio para ' +
                                'protesto para aquela(s) comarca(s)!'
                            this.showDismissibleAlert = true
                        }
                        if (erro.dividasComErro != null && erro.dividasComErro.length > 0) {
                            possuiErro = true;
                            let dividasStr = ''
                            erro.dividasComErro.forEach(divida => {
                                if (dividasStr !== '') {
                                    dividasStr += ', '
                                }
                                dividasStr += `<a href="/consultar-cda/${divida}" target="_blank">${divida}</a>`
                            })
                            if (this.dividasErro !== '') {
                                this.dividasErro += '<BR><BR>';
                            }
                            this.dividasErro += 'Não foi possível completar a operação!!! ' + dividasStr
                            this.showDismissibleAlert = true
                        }
                    }

                    if (!possuiErro) {
                        this.showDismissibleAlert = false
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Operação realizada com sucesso!!!'] });
                    }
                    this.selecteds = []
                    this.configTable.checkedAll = false
                })
                .finally(() => {
                    this.configTable.currentPage = 1
                    this.loadingExit()
                    this.consultarDividas()
                })
        },

        selecionarTodosParaProtesto() {
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).access_token;

            const filtro = this.obterFiltro()

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/selecionarTodosParaProtesto/${this.ano}/${this.mes}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then((resp) => {

                    let erro = resp.data;
                    let possuiErro = false;

                    if (erro.dividasRetornoRemessa != null && erro.dividasRetornoRemessa != '') {
                        this.erroDividasComRemessa = erro.dividasRetornoRemessa;
                        this.showModal('modalError');
                        possuiErro = true;
                    } else {
                        this.dividasErro = '';
                        if (erro.comarcasErro != null && erro.comarcasErro.length > 0) {
                            possuiErro = true;
                            let comarcasStr = ''
                            erro.comarcasErro.forEach(comarca => {
                                if (comarcasStr !== '') {
                                    comarcasStr += ', '
                                }
                                comarcasStr += `${comarca}`
                            })
                            this.dividasErro = 'Títulos da(s) comarca(s) ' + comarcasStr + ' não foram deslocados para a ' +
                                'caixa CDA’s Selecionadas em virtude de já ter sido atingido o limite diário de envio para ' +
                                'protesto para aquela(s) comarca(s)!'
                            this.showDismissibleAlert = true
                        }
                        if (erro.dividasComErro != null && erro.dividasComErro.length > 0) {
                            possuiErro = true;
                            let dividasStr = ''
                            erro.dividasComErro.forEach(divida => {
                                if (dividasStr !== '') {
                                    dividasStr += ', '
                                }
                                dividasStr += `<a href="/consultar-cda/${divida}" target="_blank">${divida}</a>`
                            })
                            if (this.dividasErro !== '') {
                                this.dividasErro += '<BR><BR>';
                            }
                            this.dividasErro += 'Não foi possível completar a operação!!! ' + dividasStr
                            this.showDismissibleAlert = true
                        }
                    }

                    if (!possuiErro) {
                        this.showDismissibleAlert = false
                        this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Operação realizada com sucesso!!!'] });
                    }
                    this.selecteds = [];
                    this.configTable.checkedAll = false;
                })
                .finally(() => {
                    this.configTable.currentPage = 1;
                    this.loadingExit();
                    this.consultarDividas();
                })
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if (this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if (i == 0 || i == 2 || i == 3 || i == 5 || i == 6)
                return 'text-center justify-content-center'
            if (i == 7)
                return 'text-right justify-content-center'
            return 'justify-content-center'
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if (this.selecteds.length) {
                let selecionadas = []
                this.selecteds.forEach(cda => {
                    selecionadas.push({
                        codCdaSefa: cda.codCdaSefa
                    })
                })

                axios.post(`${urlApi}/v1/cdaDisponivelProtesto/exportarCsv`, selecionadas, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            } else {
                const filtro = this.obterFiltro()
                axios.post(`${urlApi}/v1/cdaDisponivelProtesto/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                    .then(response => {
                        this.downloadCSV(response)
                    }).finally(() => {
                        this.loadCSV = false
                    })
            }
        },

        async relatorioPDF() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadPDF = true
            axios.get(`${urlApi}/v1/cdaDisponivelProtesto/exportarCargaSefa/${this.ano}/${this.mes}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'RelatorioCargaSEFA.pdf';
                    link.click();
                }).finally(() => {
                    this.loadPDF = false
                })
        },

        /**
         * Realizar o download do arquivo CSV recebido do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'CDADisponivelProtesto.csv');
            document.body.appendChild(link);
            link.click();
        },

        downloadPdf(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'RelatorioCargaSEFA.pdf');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        /**
         * Obter filtro
         */
        obterFiltro() {
            return {
                numeroDivida: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.numeroDivida : null,
                cpfCnpj: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.cpfCnpj : null,
                contribuinte: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.contribuinte : null,
                cadicms: (this.filtrarPor.filter(e => e.id == 4).length > 0) ? this.filtro.cadimcs : null,
                comarcas: (this.filtrarPor.filter(e => e.id == 5).length > 0) ? this.filtro.comarca : null,
                origem: (this.filtrarPor.filter(e => e.id == 6).length > 0) ? this.filtro.origem : null,
                tipoCredito: (this.filtrarPor.filter(e => e.id == 7).length > 0) ? this.filtro.credito : null,
                dtInscricaoInicio: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.dtInscricaoInicio ? this.filtro.dtInscricaoInicio.toString() : null) : null,
                dtInscricaoFim: (this.filtrarPor.filter(e => e.id == 8).length > 0) ? (this.filtro.dtInscricaoFim ? this.filtro.dtInscricaoFim.toString() : null) : null,
                situacaoCadicms: (this.filtrarPor.filter(e => e.id == 9).length > 0) ? this.filtro.situacaoCadicms : null,
                excecaoInativa: (this.filtrarPor.filter(e => e.id == 10).length > 0) ? this.filtro.excecaoInativa.nome : null,
            }
        },

        /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            let perPageStr = `&perPage=${this.configTable.perPage}`
            if (this.configTable.perPage === 'Todos') {
                perPageStr = ''
                this.configTable.currentPage = 1
                this.configTable.rows = 0
            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    this.resultado = response.data.resultado
                    this.configTable.quantidadeGeral = response.data.rows
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows
                    }

                    this.configTable.checkedAll = true
                    this.resultado.forEach(result => {
                        result.checked = false
                        this.selecteds.forEach(selected => {
                            if (result.codCdaSefa == selected.codCdaSefa) {
                                const index = this.selecteds.indexOf(selected)
                                this.selecteds.splice(index, 1)

                                this.selecteds.push(result)
                                result.checked = true
                            }
                        })

                        if (!this.selecteds.includes(result)) {
                            this.configTable.checkedAll = false
                        }
                    })

                }).finally(() => {
                    this.loadingExit()
                })

            this.consultarTotalDividas()
        },

        async consultarTotalDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = this.obterFiltro()

            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/consultar/valorTotal/${this.ano}/${this.mes}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
                .then(response => {
                    this.configTable.totalGeral = response.data
                })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar/protesto`)
                .then(response => {
                    this.dados.comarcas = response.data
                })
        },

        /**
         * Listar os Tipos de Origem
         */
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaDisponivelProtesto/listarOrigem`)
                .then(response => {
                    this.dados.origens = response.data
                })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/cdaDisponivelProtesto/listarTipoCredito`)
                .then(response => {
                    this.dados.creditos = response.data
                })
        },

        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'CDAsDisponiveisProtesto'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
                .then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            sortable: true,
                            sortDirection: "desc",
                            class: this.checkClassTable(i),
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false
        },

        async listarSituacoesCadicms() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/cdaDisponivelAjuizamento/listarSituacaoCadicms`)
                .then(response => {
                    this.dados.situacoesCadicms = response.data
                })
        },

        showModal(id) {
            this.$refs[id].show();
        },

        hideModal(id) {
            this.$refs[id].hide();
        },

        encaminharExecoes() {
            if (!this.justificativa) {
                return;
            }

            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).access_token;

            let selecionadas = []
            this.selecteds.forEach(cda => {
                selecionadas.push({
                    codCdaSefa: cda.codCdaSefa,
                    numeroDivida: cda.numeroDivida
                })
            })

            this.hideModal('modalJustificativa');
            this.loadingEnter();

            axios.post(`${urlApi}/v1/cdaDisponivelProtesto/encaminharExecoes?justificativa=` + this.justificativa, selecionadas, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success', errors: ['Processos encaminhados para exceções com sucesso.'] });
                this.selecteds = [];
                this.justificativa = "";
            })
                .finally(() => {
                    this.loadingExit();
                    this.consultarDividas();
                })
        }

    },
    mounted() {
        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoOrigem()
        this.listarTipoCredito()

        this.consultarDividas()

        this.listarSituacoesCadicms();

    }
}
</script>

<style></style>
